var React = require('react');

function VolumeMax (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 5L6 9H2v6h4l5 4V5zM19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"}));
}

VolumeMax.defaultProps = {"viewBox":"0 0 24 24","fill":"none","stroke":"#fff","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = VolumeMax;

VolumeMax.default = VolumeMax;
